import { z } from 'zod';
import type { WidgetChatRequest } from '../widget/types';

const LocaleSchema = z.string().regex(/^[a-z]{2}(-[A-Z]{2})?$/);

export const WidgetChatRequestSchema = z.object({
  message: z.string().min(1).max(4000),
  sessionId: z.string().uuid(),
  conversationId: z.string().uuid().nullable().optional(),
  metadata: z.object({
    channel: z.literal('external-widget'),
    url: z.string().url(),
    title: z.string().max(500).nullable().optional(),
    locale: LocaleSchema.nullable().optional(),
    referrer: z.string().url().nullable().optional(),
    userAgent: z.string().max(500).nullable().optional(),
  }),
});

export function validateChatRequest(input: WidgetChatRequest): WidgetChatRequest {
  return WidgetChatRequestSchema.parse(input);
}

